export default __webpack_public_path__ + "static/media/tesselated.db632abb.mp3";